import React from 'react';
import { Image, XStack, YStack } from 'tamagui';

interface IconSectionProps {
  iconSrc: string;
  iconBgColor: string;
  iconColor: string;
  brandLogoSrc?: string;
}

export const IconSection: React.FC<IconSectionProps> = ({
  iconSrc,
  iconBgColor,
  iconColor,
  brandLogoSrc,
}) => (
  <YStack flex={1} justifyContent="flex-start">
    <XStack alignItems="center">
      <YStack
        width={96}
        height={96}
        borderRadius={96 / 2}
        backgroundColor={iconBgColor}
        alignItems="center"
        justifyContent="center">
        <Image
          source={{ uri: iconSrc }}
          width={64}
          height={64}
          resizeMode="contain"
          tintColor={iconColor}
        />
      </YStack>

      <XStack flex={1} justifyContent="flex-end">
        {brandLogoSrc && (
          <Image source={{ uri: brandLogoSrc }} width={184} height={50} resizeMode="contain" />
        )}
      </XStack>
    </XStack>
  </YStack>
);
